export type TAriaBoolean = 'true' | 'false';

/**
 * A boolean ARIA state as the attribute value. Vue 2 removes an attribute
 * bound to `false`, so states like `aria-expanded="false"` must be strings;
 * `undefined` leaves the attribute out.
 */
export function ariaBoolean(
  value: boolean | undefined
): TAriaBoolean | undefined {
  if (value === undefined) return undefined;
  return value ? 'true' : 'false';
}

export interface IChipAriaAttributes {
  role?: 'radio';
  'aria-checked'?: TAriaBoolean;
  'aria-pressed'?: TAriaBoolean;
}

/**
 * ARIA of `PosUiChip`: a toggle (`aria-pressed`) when `active` is given, a
 * radio (`role="radio"` + `aria-checked`, always set) inside a radiogroup, and
 * nothing for a one-shot chip.
 */
export function chipAriaAttributes(
  active: boolean | undefined,
  radio: boolean
): IChipAriaAttributes {
  if (radio) return { role: 'radio', 'aria-checked': ariaBoolean(!!active) };
  const pressed = ariaBoolean(active);
  return pressed === undefined ? {} : { 'aria-pressed': pressed };
}
